import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'

import Card from 'components/Card'

export const CardContainer = styled(Card)`
  padding: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`

export const TableContainer = styled.table`
  min-width: 100%;
  border-collapse: collapse;
  border-radius: ${({ theme }) => theme.radii.default};
`

export const TableHeader = styled.thead`
  background-color: ${({ theme }) => theme.colors.grays.N050};
  border-bottom: 2px solid ${({ theme }) => theme.colors.grays.N300};
`

export const TableBody = styled.tbody``

export const TableFooter = styled.tfoot`
  border-top: 1px solid ${({ theme }) => theme.colors.grays.N200};
`

export const TableRow = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grays.N200};

  :last-child {
    border-bottom: none;
  }
`

export const TableCell = styled.td`
  padding: 6px 8px;
  text-align: ${props => (props.align ? props.align : 'left')};
  font-size: 14px;
  line-height: 19px;
  ${props =>
    props.customStyle
      ? css`
          ${props.customStyle}
        `
      : ''};
  ${props =>
    props.as === 'th' &&
    css`
      color: ${props.theme.colors.grays.N600};
      text-transform: uppercase;
      font-size: 12px;
      line-height: 16px;
    `};
`
export const InputLabel = styled.label(
  ({ theme, focused }) => css`
    color: ${theme.colors.grays.N500};
    background-color: #fff;
    padding: 0 4px;
    text-transform: uppercase;
    font-size: ${theme.fontSizes.label};
    font-weight: ${theme.fontWeights.extraBold};

    transition: color 0.2s;

    ${focused &&
      css`
        color: ${theme.colors.primary};
      `}
  `,
)

export const Input = styled.input(
  ({ theme }) => css`
    display: block;
    width: 100%;
    border: 1px solid;
    border-color: ${theme.colors.grays.N500};
    border-radius: 8px;
    padding: 7px 16px;
    transition: all 0.2s;
    font-family: ${theme.fonts.body};
    font-size: ${theme.fontSizes.body};
    color: ${theme.colors.text};

    :focus {
      border-color: ${theme.colors.primary};
      box-shadow: ${theme.shadows.under[1]};
    }

    :focus ~ ${InputLabel} {
      color: ${theme.colors.primary};
    }
  `,
)

export const NavigationButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.grays.N500};
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.colors.grays.N600};
  }

  :disabled {
    color: ${({ theme }) => theme.colors.grays.N400};
    cursor: not-allowed;
  }
`

export const NavigationInfo = styled.span`
  margin: 0 1rem;
  strong {
    margin-left: 4px;
  }
`

export const StyledReactSelect = styled(ReactSelect)`
  width: 100%;
`
